<template>
  <ul class="award-image-list">
    <li
      v-for="award in awards"
      :key="award.title"
      class="award-image-list__item"
    >
      <BasicTooltip :content="award.title">
        <BasicLink
          full-width
          :href="award.href"
        >
          <img
            class="award-image-list__image"
            :src="award.image.src"
            :alt="award.title"
          >
        </BasicLink>
      </BasicTooltip>
    </li>
  </ul>
</template>

<script>
  import BasicLink from 'src/components/BasicLink/BasicLink.vue';
  import BasicTooltip from 'src/components/BasicTooltip/BasicTooltip.vue';
  
  export default {
    name: 'AwardImageList',
    components: { BasicLink, BasicTooltip },
    props: {
      awards: {
        type: Array,
        required: true,
      }
    }
  }
</script>